import { 
    DELIVERIES_CONNECT,
    DELIVERIES_DISCONNECT,
    DELIV_DONE,
    DELIVERIES_UPDATE,
    DELIVERIES_ERROR,
    DELIV_START,
    DELIV_START_UPD
} from "../../constants/action-types";

export function delivDone(data){
    return { type: DELIV_DONE, payload: data } }

export function deliveriesConnect(data){
    return { type: DELIVERIES_CONNECT, payload: data } }

export function deliveriesDisconnect(data){
    return { type: DELIVERIES_DISCONNECT, payload: data } }

export function deliveriesUpdate(data){
    return { type: DELIVERIES_UPDATE, payload: data } }

export function deliveriesError(data){
    return { type: DELIVERIES_ERROR, payload: data } }

export function delivStart(data){
    return { type: DELIV_START, payload: data } }

export function delivStartUpd(data){
    return { type: DELIV_START_UPD, payload: data } }



// WEBPACK FOOTER //
// ./src/store/actions/deliveries.js